var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import theme from "../../styles/theme";
var colors = theme.colors;
var ConsultationPencil = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primary : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 28 27", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "m23.348 9.2573-5.6053-5.6053 1.3376-1.3376 5.6053 5.6053-1.3376 1.3376z", fill: color }),
        React.createElement("path", { d: "m8.6127 23.915-5.527-5.3081 13.759-13.206 5.527 5.3081-13.759 13.206z", fill: color }),
        React.createElement("path", { d: "m27.07 5.7788c0.9351-0.83148 0.9351-2.1618 0-2.9933l-2.4312-2.1618c-0.935-0.83148-2.5246-0.83148-3.3662 0l-1.2156 1.0809 5.8909 5.2383 1.1221-1.1641z", fill: color }),
        React.createElement("path", { d: "m0.035441 26.184c-0.090339 0.245 0 0.4901 0.18068 0.6534 0.09034 0.0817 0.27102 0.1634 0.4517 0.1634h0.27102l6.7755-2.2054-5.2397-4.7375-2.4392 6.1261z", fill: color })));
};
export default ConsultationPencil;
//# sourceMappingURL=ConsultationPencil.js.map